import { render, staticRenderFns } from "./MyComment.vue?vue&type=template&id=778d90fb&scoped=true"
import script from "./MyComment.vue?vue&type=script&lang=js"
export * from "./MyComment.vue?vue&type=script&lang=js"
import style0 from "./MyComment.vue?vue&type=style&index=0&id=778d90fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778d90fb",
  null
  
)

export default component.exports